export const duration = 0.2;
export const transition = { duration: duration, ease: [0.43, 0.13, 0.23, 0.96] };
